// extracted by mini-css-extract-plugin
export default {"tableRow":"AssignToWorkTableWorkerRow_tableRow__qQW98","tableHeader":"AssignToWorkTableWorkerRow_tableHeader__5cpoB","tableContent":"AssignToWorkTableWorkerRow_tableContent__T8F90"};